<template>
  <div class="kt-grid kt-grid--ver kt-grid--root">
    <h3 style="color: white;">.</h3>
    <div
      class="kt-grid__item kt-grid__item--fluid kt-grid kt-error-v4"
      :style="{
        backgroundImage: `url(${backgroundImage})`
      }"
    >
      <div class="kt-error_container">
        <h1 class="kt-error_number">
          403
        </h1>
        <p class="kt-error_title">
          Access Denied
        </p>
        <p class="kt-error_description">
          You are not authorized to view this page.
        </p>
        <br />
        <br />
        <p class="kt-error_description">
          Redirecting to login in {{ countdown }} seconds...
        </p>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
@import "@/assets/sass/pages/error/error-4.scss";
</style>

<script>
export default {
  name: "Error-4",
  data() {
    return {
      countdown: 5,
      timer: null
    };
  },
  mounted() {
    this.timer = setInterval(() => {
      this.countdown--;
      if (this.countdown <= 0) {
        clearInterval(this.timer);
        this.$router.push({ name: "login" });
      }
    }, 1000);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  computed: {
    backgroundImage() {
      return process.env.BASE_URL + "assets/media/error/bg5.jpg";
    }
  }
};
</script>
